export function createGuestSettings(json) {
  var _json$canAddGuests, _json$maxGuestCount;
  return {
    canAddGuests: (_json$canAddGuests = json === null || json === void 0 ? void 0 : json.canAddGuests) !== null && _json$canAddGuests !== void 0 ? _json$canAddGuests : false,
    maxGuestCount: Math.max(0, Math.min((_json$maxGuestCount = json === null || json === void 0 ? void 0 : json.maxGuestCount) !== null && _json$maxGuestCount !== void 0 ? _json$maxGuestCount : 10, 10))
  };
}